angular.module('theme').directive('testWeekLink', function ($cookies, $window) {
	return {
		restrict: 'A',
		link: function ($scope, $element, $attrs) {
			
			angular.element($element[0]).bind('click', function (event) {
				event.preventDefault();
				$cookies.put('test-week', 'Test', {
					path: '/',
					expires: moment().add(1, 'month').toDate()
				});
				if($attrs.href) {
					$window.location.href = $attrs.href;
				}
			});
			
		}
	};
});